import { Injectable } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

type Validator = (focus: boolean) => boolean;

@Injectable()
export class FormService {
  private validators = new Map<string, Validator>();

  addValidator(id: string, validator: Validator) {
    if (this.validators.has(id)) {
      return;
    }
    this.validators.set(id, validator);
  }

  removeValidator(id: string) {
    this.validators.delete(id);
  }

  checkFormValidity(formGroup: FormGroup) {
    this.updateFormValidity(formGroup);
    if (formGroup.valid) {
      return true;
    }
    let focus = true;
    for (const validateFn of this.validators.values()) {
      focus = validateFn(focus) && focus;
    }
    return false;
  }

  private updateFormValidity<U extends AbstractControl>(control: U) {
    if (control instanceof FormGroup) {
      const controls = control.controls;
      Object.keys(controls).forEach((key) => {
        controls[key].updateValueAndValidity();
        if (!controls[key].valid) {
          controls[key].markAsDirty();
        }
        this.updateFormValidity(controls[key]);
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach((formControl) => {
        this.updateFormValidity(formControl);
      });
    } else if (control instanceof FormControl) {
      if (!control.valid) {
        control.markAsDirty();
      }
    }
  }
}
